import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CSSTransition } from 'react-transition-group';
import { AppState } from '../../../store/store';
import { NavItemsData } from '../Nav/Nav';
import { AiOutlineMenu } from 'react-icons/ai';

import './MenuButton.scss';
import { t } from 'i18next';

export const MenuButton = (): ReactElement => {
  const [openMenu, setOpenMenu] = useState(false);
  const ref = React.useRef<HTMLDivElement>(null);
  const menuRef = React.useRef<HTMLDivElement>(null);
  const curPath = useSelector(
    (state: AppState) => state.router.location.pathname,
  );

  const toggleMenu = (isOpen: boolean) => {
    if (isOpen) {
      document.addEventListener('click', handleOutsideClick, false);
    } else {
      document.removeEventListener('click', handleOutsideClick, false);
    }

    setOpenMenu(isOpen);
  };

  const handleOutsideClick = (e: any) => {
    if (!ref.current?.contains(e.target)) {
      toggleMenu(false);
    }
  };

  const renderMenu = (): ReactElement => {
    return (
      <CSSTransition
        nodeRef={menuRef}
        in={openMenu}
        timeout={300}
        unmountOnExit
        classNames="app-bar__menu"
      >
        <div ref={menuRef} className="app-bar__menu">
          <ul>
            {NavItemsData.map((item) => (
              <li key={item.name} className="app-bar__menu-item">
                <Link
                  key={item.name}
                  className={`app-bar__nav-link${
                    curPath === item.path ? '--selected' : ''
                  }`}
                  to={item.path}
                  onClick={() => {
                    toggleMenu(false);
                  }}
                >
                  {t(item.name)}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </CSSTransition>
    );
  };

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <div
        className="app-bar__menu-btn"
        onClick={() => {
          toggleMenu(!openMenu);
        }}
      >
        <AiOutlineMenu />
      </div>
      {renderMenu()}
    </div>
  );
};
